export function isPlaceholderEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return normalized.includes("@") && (normalized.endsWith(".invalid") || normalized.endsWith("@invalid"));
}
